export function SearchIcon() {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.62498 17.4166C13.9283 17.4166 17.4166 13.9282 17.4166 9.62492C17.4166 5.32163 13.9283 1.83325 9.62498 1.83325C5.32169 1.83325 1.83331 5.32163 1.83331 9.62492C1.83331 13.9282 5.32169 17.4166 9.62498 17.4166Z"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M12.2177 6.57388C11.8776 6.23289 11.4735 5.96248 11.0285 5.77819C10.5836 5.5939 10.1066 5.49936 9.62496 5.5C9.14334 5.49936 8.66635 5.5939 8.22139 5.77819C7.77643 5.96248 7.37228 6.23289 7.03217 6.57388M15.2267 15.2268L19.1157 19.1157"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function BagIconLight() {
  return (
    <>
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.75 4.77515V17.7918C1.75 18.0349 1.84658 18.2681 2.01849 18.44C2.19039 18.6119 2.42355 18.7085 2.66667 18.7085H17.3333C17.5764 18.7085 17.8096 18.6119 17.9815 18.44C18.1534 18.2681 18.25 18.0349 18.25 17.7918V4.77515H1.75Z"
          stroke="#fff"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 4.77508L15.6526 1.29175H4.34737L1.75 4.77508M13.4627 7.80008C13.4627 9.72417 11.9126 11.2834 10 11.2834C8.08738 11.2834 6.53683 9.72417 6.53683 7.80008"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function UserIconLight() {
  return (
    <>
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99998 9.16659C12.025 9.16659 13.6666 7.52496 13.6666 5.49992C13.6666 3.47487 12.025 1.83325 9.99998 1.83325C7.97494 1.83325 6.33331 3.47487 6.33331 5.49992C6.33331 7.52496 7.97494 9.16659 9.99998 9.16659Z"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 20.1665C18.25 15.6102 14.5563 11.9165 10 11.9165C5.44371 11.9165 1.75 15.6102 1.75 20.1665"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function DownIconLight() {
  return (
    <>
      <svg
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 0.5L5 4.5L1 0.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function ParkGreenIcon() {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33337 20.6666V28C5.33337 28.3536 5.47385 28.6927 5.7239 28.9428C5.97395 29.1928 6.31309 29.3333 6.66671 29.3333H25.3334C25.687 29.3333 26.0261 29.1928 26.2762 28.9428C26.5262 28.6927 26.6667 28.3536 26.6667 28V20.6666"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.3334 9.33325H6.66671C6.31309 9.33325 5.97395 9.47373 5.7239 9.72378C5.47385 9.97382 5.33337 10.313 5.33337 10.6666V14.6666C5.33337 15.0202 5.47385 15.3593 5.7239 15.6094C5.97395 15.8594 6.31309 15.9999 6.66671 15.9999H25.3334C25.687 15.9999 26.0261 15.8594 26.2762 15.6094C26.5262 15.3593 26.6667 15.0202 26.6667 14.6666V10.6666C26.6667 10.313 26.5262 9.97382 26.2762 9.72378C26.0261 9.47373 25.687 9.33325 25.3334 9.33325Z"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M10.6667 2.66663V5.33329M16.0001 2.66663V5.33329M21.3334 2.66663V5.33329M10.6667 22.6666H21.3334"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function BackGreenIcon() {
  return (
    <>
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.16667 5.33337L4.5 9.33337L9.16667 14"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 9.33337H19.8293C24.418 9.33337 28.3147 13.08 28.4933 17.6667C28.6827 22.5134 24.678 26.6667 19.8293 26.6667H8.49867"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function FacebookGreenIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.001 0.00195312C4.47901 0.00195312 0.00201416 4.47895 0.00201416 10.001C0.00201416 14.991 3.65801 19.127 8.43901 19.88V12.892H5.89901V10.001H8.43901V7.79795C8.43901 5.28995 9.93201 3.90695 12.215 3.90695C13.309 3.90695 14.455 4.10195 14.455 4.10195V6.56095H13.191C11.951 6.56095 11.563 7.33295 11.563 8.12395V9.99895H14.334L13.891 12.89H11.563V19.878C16.344 19.129 20 14.992 20 10.001C20 4.47895 15.523 0.00195312 10.001 0.00195312Z"
          fill="#16FF96"
        />
      </svg>
    </>
  );
}
export function InstagramGreenIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.999 7.37695C10.7726 7.37695 9.59651 7.86412 8.72934 8.73129C7.86217 9.59846 7.375 10.7746 7.375 12.001C7.375 13.2273 7.86217 14.4034 8.72934 15.2706C9.59651 16.1378 10.7726 16.625 11.999 16.625C13.2254 16.625 14.4015 16.1378 15.2687 15.2706C16.1358 14.4034 16.623 13.2273 16.623 12.001C16.623 10.7746 16.1358 9.59846 15.2687 8.73129C14.4015 7.86412 13.2254 7.37695 11.999 7.37695ZM11.999 15.004C11.2023 15.004 10.4382 14.6875 9.87485 14.1241C9.31149 13.5607 8.995 12.7967 8.995 12C8.995 11.2032 9.31149 10.4392 9.87485 9.8758C10.4382 9.31245 11.2023 8.99595 11.999 8.99595C12.7957 8.99595 13.5598 9.31245 14.1231 9.8758C14.6865 10.4392 15.003 11.2032 15.003 12C15.003 12.7967 14.6865 13.5607 14.1231 14.1241C13.5598 14.6875 12.7957 15.004 11.999 15.004Z"
          fill="#16FF96"
        />
        <path
          d="M16.806 8.28491C17.4014 8.28491 17.884 7.80227 17.884 7.20691C17.884 6.61154 17.4014 6.12891 16.806 6.12891C16.2107 6.12891 15.728 6.61154 15.728 7.20691C15.728 7.80227 16.2107 8.28491 16.806 8.28491Z"
          fill="#16FF96"
        />
        <path
          d="M20.533 6.11088C20.3015 5.51306 19.9477 4.97017 19.4943 4.51694C19.041 4.06372 18.4979 3.71015 17.9 3.47888C17.2003 3.21624 16.4612 3.07422 15.714 3.05888C14.751 3.01688 14.446 3.00488 12.004 3.00488C9.56201 3.00488 9.24901 3.00488 8.29401 3.05888C7.5474 3.07344 6.80877 3.21548 6.11001 3.47888C5.51195 3.70988 4.96878 4.06335 4.51535 4.51661C4.06192 4.96987 3.70824 5.51291 3.47701 6.11088C3.21432 6.8105 3.07263 7.54972 3.05801 8.29688C3.01501 9.25888 3.00201 9.56388 3.00201 12.0069C3.00201 14.4489 3.00201 14.7599 3.05801 15.7169C3.07301 16.4649 3.21401 17.2029 3.47701 17.9039C3.70889 18.5016 4.06291 19.0445 4.51645 19.4977C4.96999 19.9509 5.51308 20.3045 6.11101 20.5359C6.80845 20.8091 7.54739 20.9613 8.29601 20.9859C9.25901 21.0279 9.56401 21.0409 12.006 21.0409C14.448 21.0409 14.761 21.0409 15.716 20.9859C16.4631 20.9707 17.2022 20.829 17.902 20.5669C18.4998 20.3351 19.0426 19.9812 19.496 19.5279C19.9493 19.0745 20.3032 18.5316 20.535 17.9339C20.798 17.2339 20.939 16.4959 20.954 15.7479C20.997 14.7859 21.01 14.4809 21.01 12.0379C21.01 9.59488 21.01 9.28488 20.954 8.32788C20.9424 7.57016 20.7999 6.82013 20.533 6.11088ZM19.315 15.6429C19.3086 16.2192 19.2034 16.7901 19.004 17.3309C18.8538 17.7198 18.6239 18.0729 18.3291 18.3676C18.0342 18.6622 17.681 18.8919 17.292 19.0419C16.7572 19.2403 16.1924 19.3455 15.622 19.3529C14.672 19.3969 14.404 19.4079 11.968 19.4079C9.53001 19.4079 9.28101 19.4079 8.31301 19.3529C7.74294 19.3459 7.17834 19.2407 6.64401 19.0419C6.2537 18.8929 5.89902 18.6636 5.6029 18.3688C5.30679 18.0741 5.07585 17.7205 4.92501 17.3309C4.72846 16.7959 4.62333 16.2317 4.61401 15.6619C4.57101 14.7119 4.56101 14.4439 4.56101 12.0079C4.56101 9.57088 4.56101 9.32188 4.61401 8.35288C4.62048 7.77691 4.72567 7.2063 4.92501 6.66588C5.23001 5.87688 5.85501 5.25588 6.64401 4.95388C7.1786 4.75602 7.74304 4.65085 8.31301 4.64288C9.26401 4.59988 9.53101 4.58788 11.968 4.58788C14.405 4.58788 14.655 4.58788 15.622 4.64288C16.1924 4.64974 16.7574 4.75495 17.292 4.95388C17.6809 5.10416 18.0342 5.33408 18.329 5.62891C18.6238 5.92374 18.8537 6.27695 19.004 6.66588C19.2006 7.20083 19.3057 7.76504 19.315 8.33488C19.358 9.28588 19.369 9.55288 19.369 11.9899C19.369 14.4259 19.369 14.6879 19.326 15.6439H19.315V15.6429Z"
          fill="#16FF96"
        />
      </svg>
    </>
  );
}
export function TwitterGreenIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="100"
        height="100"
        viewBox="0 0 50 50"
      >
        <path
          d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"
          fill="#16FF96"
        ></path>
      </svg>
    </>
  );
}
export function YoutubeGreenIcon() {
  return (
    <>
      <svg
        width="21"
        height="15"
        viewBox="0 0 21 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.593 2.20301C20.4791 1.78041 20.2565 1.39501 19.9474 1.08518C19.6383 0.775338 19.2534 0.551868 18.831 0.437007C17.265 0.00700739 11 7.59651e-06 11 7.59651e-06C11 7.59651e-06 4.73602 -0.00699261 3.16902 0.404007C2.74695 0.524154 2.36285 0.750785 2.05359 1.06214C1.74433 1.3735 1.52031 1.75913 1.40302 2.18201C0.990025 3.74801 0.986024 6.99601 0.986024 6.99601C0.986024 6.99601 0.982024 10.26 1.39202 11.81C1.62202 12.667 2.29702 13.344 3.15502 13.575C4.73702 14.005 10.985 14.012 10.985 14.012C10.985 14.012 17.25 14.019 18.816 13.609C19.2385 13.4943 19.6238 13.2714 19.9337 12.9622C20.2436 12.653 20.4674 12.2682 20.583 11.846C20.997 10.281 21 7.03401 21 7.03401C21 7.03401 21.02 3.76901 20.593 2.20301ZM8.99603 10.005L9.00103 4.00501L14.208 7.01001L8.99603 10.005Z"
          fill="#16FF96"
        />
      </svg>
    </>
  );
}
export function UserGreyIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            d="M11.0002 9.16667C13.0252 9.16667 14.6668 7.52504 14.6668 5.5C14.6668 3.47496 13.0252 1.83333 11.0002 1.83333C8.97512 1.83333 7.3335 3.47496 7.3335 5.5C7.3335 7.52504 8.97512 9.16667 11.0002 9.16667Z"
            stroke="#2C2E3A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.25 20.1667C19.25 15.6104 15.5563 11.9167 11 11.9167C6.44371 11.9167 2.75 15.6104 2.75 20.1667"
            stroke="#2C2E3A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </>
  );
}
export function KeyGreyIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            d="M10.4811 11.1366C11.0531 11.6968 11.4661 12.3988 11.6779 13.1709C11.8897 13.943 11.8926 14.7575 11.6865 15.5311C11.4786 16.3059 11.0695 17.0119 10.5008 17.5776C9.93202 18.1433 9.2238 18.5485 8.44792 18.7523C7.67118 18.9577 6.85407 18.9551 6.07866 18.7447C5.30326 18.5343 4.59688 18.1236 4.0305 17.5537C3.1999 16.7 2.73979 15.553 2.75017 14.3619C2.76056 13.1709 3.24059 12.0321 4.08596 11.193C5.8455 9.44213 8.69037 9.41783 10.4802 11.1375L10.4811 11.1366V11.1366Z"
            stroke="#2C2E3A"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M10.5415 11L18.3332 3.20833"
            stroke="#2C2E3A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.8896 7.74583L16.3779 10.2208L19.2806 7.33333L16.7927 4.85833L13.8896 7.74583V7.74583Z"
            stroke="black"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </>
  );
}
export function EyeGreyIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0002 16.5C16.0629 16.5 20.1668 11 20.1668 11C20.1668 11 16.0629 5.5 11.0002 5.5C5.93741 5.5 1.8335 11 1.8335 11C1.8335 11 5.93741 16.5 11.0002 16.5Z"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M11.0002 13.2917C11.608 13.2917 12.1908 13.0502 12.6206 12.6205C13.0504 12.1907 13.2918 11.6078 13.2918 11C13.2918 10.3922 13.0504 9.80932 12.6206 9.37955C12.1908 8.94978 11.608 8.70833 11.0002 8.70833C10.3924 8.70833 9.80948 8.94978 9.37971 9.37955C8.94994 9.80932 8.7085 10.3922 8.7085 11C8.7085 11.6078 8.94994 12.1907 9.37971 12.6205C9.80948 13.0502 10.3924 13.2917 11.0002 13.2917Z"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function ClosedEyeGreyIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.51792 8.25C2.85876 9.625 1.83301 11 1.83301 11C1.83301 11 5.93692 16.5 10.9997 16.5C11.6276 16.5 12.2408 16.4152 12.833 16.2672M9.18101 5.72917C9.76859 5.58342 10.3773 5.5 10.9997 5.5C16.0624 5.5 20.1663 11 20.1663 11C20.1663 11 19.1401 12.375 17.4814 13.75M9.31026 9.45129C8.90497 9.89122 8.68776 10.4722 8.705 11.0701C8.72224 11.668 8.97258 12.2355 9.40254 12.6513C9.8325 13.0671 10.408 13.2984 11.0062 13.2957C11.6043 13.2929 12.1777 13.0565 12.6038 12.6367M19.2497 19.25L2.74967 2.75"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function GooglePlusIcon() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_984_9094)">
          <path
            d="M15.9922 8.14968C15.9922 7.49417 15.9377 7.01582 15.8199 6.51976H8.15918V9.47842H12.6559C12.5652 10.2137 12.0757 11.321 10.9877 12.065L10.9725 12.1641L13.3947 13.9976L13.5625 14.0139C15.1037 12.6231 15.9922 10.5769 15.9922 8.14968Z"
            fill="#4285F4"
          />
          <path
            d="M8.15918 15.945C10.3622 15.945 12.2116 15.2363 13.5625 14.0139L10.9877 12.065C10.2987 12.5345 9.37399 12.8623 8.15918 12.8623C6.00149 12.8623 4.17018 11.4716 3.51737 9.54932L3.42168 9.55726L0.903055 11.4618L0.870117 11.5513C2.21187 14.1556 4.96793 15.945 8.15918 15.945Z"
            fill="#34A853"
          />
          <path
            d="M3.51756 9.54932C3.34531 9.05326 3.24563 8.52171 3.24563 7.97252C3.24563 7.42327 3.34531 6.89179 3.5085 6.39573L3.50394 6.29008L0.95375 4.35493L0.870313 4.39371C0.317313 5.47445 0 6.68806 0 7.97252C0 9.25698 0.317313 10.4705 0.870313 11.5513L3.51756 9.54932Z"
            fill="#FBBC05"
          />
          <path
            d="M8.15918 3.08269C9.69131 3.08269 10.7248 3.72934 11.3141 4.26974L13.6169 2.07286C12.2026 0.788397 10.3622 0 8.15918 0C4.96793 0 2.21187 1.78937 0.870117 4.39371L3.5083 6.39573C4.17018 4.47347 6.00149 3.08269 8.15918 3.08269Z"
            fill="#EB4335"
          />
        </g>
        <defs>
          <clipPath id="clip0_984_9094">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
export function FacebookBlueIcon() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8C16 3.58175 12.4183 0 8 0C3.58175 0 0 3.58169 0 8C0 11.993 2.9255 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94438 3.125 9.77169 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5538C9.55988 5.25 9.25 5.86669 9.25 6.49937V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.9931 16 8Z"
          fill="#1877F2"
        />
      </svg>
    </>
  );
}
export function FacebookBlueIcon2() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 8C16 3.58175 12.4183 0 8 0C3.58175 0 0 3.58169 0 8C0 11.993 2.9255 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94438 3.125 9.77169 3.125C10.647 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5538C9.55988 5.25 9.25 5.86669 9.25 6.49937V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.9931 16 8Z"
        />
      </svg>
    </>
  );
}
export function CalendarIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.04175 8.70834H18.4584V18.3333C18.4584 18.5765 18.3618 18.8096 18.1899 18.9815C18.018 19.1534 17.7849 19.25 17.5417 19.25H1.95841C1.7153 19.25 1.48214 19.1534 1.31023 18.9815C1.13833 18.8096 1.04175 18.5765 1.04175 18.3333V8.70834ZM1.04175 4.125C1.04175 3.88189 1.13833 3.64873 1.31023 3.47682C1.48214 3.30491 1.7153 3.20834 1.95841 3.20834H17.5417C17.7849 3.20834 18.018 3.30491 18.1899 3.47682C18.3618 3.64873 18.4584 3.88189 18.4584 4.125V8.70834H1.04175V4.125Z"
        stroke="#2C2E3A"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6.08341 1.83334V5.5M13.4167 1.83334V5.5M11.5834 15.5833H14.3334M5.16675 15.5833H7.91675M11.5834 11.9167H14.3334M5.16675 11.9167H7.91675"
        stroke="#2C2E3A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function Star() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.28531 1.49599L6.28536 1.49616L7.14136 4.12976L7.14151 4.1302C7.22649 4.39084 7.39169 4.61793 7.6135 4.77904C7.83531 4.94014 8.10237 5.027 8.37651 5.0272H8.37688H11.1465C11.4359 5.0272 11.5589 5.39887 11.3227 5.57093C11.3226 5.57094 11.3226 5.57096 11.3226 5.57097L9.08327 7.19768C9.08319 7.19775 9.0831 7.19781 9.08301 7.19787C8.86088 7.3591 8.69548 7.5865 8.61051 7.84749C8.5255 8.10859 8.52535 8.38989 8.61007 8.65108L8.61016 8.65136L9.46616 11.285L9.46626 11.2853C9.5558 11.5601 9.24055 11.7923 9.00354 11.6203C9.00351 11.6203 9.00348 11.6202 9.00346 11.6202L6.76354 9.99307L6.76343 9.99299C6.54139 9.83179 6.27405 9.74498 5.99968 9.74498C5.7253 9.74498 5.45796 9.83179 5.23593 9.99299L5.23581 9.99307L2.99581 11.6203L2.99565 11.6204C2.76121 11.7908 2.44404 11.562 2.53404 11.2848L3.38999 8.65136L3.39008 8.65108C3.47481 8.38989 3.47465 8.10859 3.38965 7.84749C3.30464 7.58639 3.13914 7.35892 2.91688 7.19768L0.678347 5.57177C0.678279 5.57172 0.67821 5.57167 0.678142 5.57162C0.442602 5.39989 0.565293 5.028 0.854477 5.028L3.62315 5.028C3.62319 5.028 3.62323 5.028 3.62328 5.028C3.89759 5.02805 4.16489 4.94132 4.38693 4.78022C4.60899 4.6191 4.77439 4.39185 4.85945 4.131L4.85959 4.13056L5.71559 1.49696L5.72363 1.47221C5.82826 1.21943 6.19865 1.22904 6.28531 1.49599Z"
        fill="#16FF96"
        stroke="#2C2E3A"
      />
    </svg>
  );
}
export function SearchGrayIcon() {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.62467 17.4168C13.928 17.4168 17.4163 13.9285 17.4163 9.62516C17.4163 5.32187 13.928 1.8335 9.62467 1.8335C5.32138 1.8335 1.83301 5.32187 1.83301 9.62516C1.83301 13.9285 5.32138 17.4168 9.62467 17.4168Z"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M12.2178 6.57388C11.8777 6.23289 11.4735 5.96248 11.0286 5.77819C10.5836 5.5939 10.1066 5.49936 9.62502 5.5C9.14341 5.49936 8.66641 5.5939 8.22145 5.77819C7.7765 5.96248 7.37234 6.23289 7.03223 6.57388M15.2268 15.2268L19.1157 19.1157"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function PlusIcon() {
  return (
    <>
      <svg
        width="9"
        height="9"
        viewBox="0 0 9 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.28 3.792V5.424H3.464V8.624H5.096V5.424H8.28V3.792H5.096V0.608H3.464V3.792H0.28Z"
          fill="#2C2E3A"
        />
      </svg>
    </>
  );
}

export function MinusIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-dash"
        viewBox="0 0 16 16"
      >
        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
      </svg>
    </>
  );
}

export function SupportIcon() {
  return (
    <>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99967 0.333344C3.32367 0.333344 0.333008 3.32401 0.333008 7.00001C0.333008 10.676 3.32367 13.6667 6.99967 13.6667C10.6757 13.6667 13.6663 10.676 13.6663 7.00001C13.6663 3.32401 10.6757 0.333344 6.99967 0.333344ZM7.66634 11H6.33301V9.66668H7.66634V11ZM8.31701 7.74334C8.18634 7.84868 8.06034 7.94934 7.96034 8.04934C7.68834 8.32068 7.66701 8.56734 7.66634 8.57801V8.66668H6.33301V8.55534C6.33301 8.47668 6.35234 7.77068 7.01701 7.10601C7.14701 6.97601 7.30834 6.84401 7.47767 6.70668C7.96701 6.31001 8.28834 6.02068 8.28834 5.62201C8.28059 5.28522 8.14134 4.96484 7.90038 4.72942C7.65942 4.494 7.33589 4.36224 6.99902 4.36232C6.66214 4.36241 6.33868 4.49434 6.09784 4.72989C5.857 4.96544 5.71791 5.28589 5.71034 5.62268H4.37701C4.37701 4.17668 5.55367 3.00001 6.99967 3.00001C8.44567 3.00001 9.62234 4.17668 9.62234 5.62268C9.62234 6.68734 8.83634 7.32268 8.31701 7.74334Z"
          fill="#1F1F1F"
        />
      </svg>
    </>
  );
}
export function WritereviewIcon() {
  return (
    <>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 4L9.456 5.8515L11.5 6.1485L10 7.5L10.5 9.5L8.5 8.375L6.5 9.5L7 7.5L5.5 6.1485L7.6 5.8515L8.5 4Z"
          fill="#1F1F1F"
        />
        <path
          d="M9.368 15L8.5 14.5L10.5 11H13.5C13.6314 11.0002 13.7615 10.9745 13.8829 10.9243C14.0043 10.8741 14.1146 10.8004 14.2075 10.7075C14.3004 10.6146 14.3741 10.5043 14.4243 10.3829C14.4745 10.2615 14.5002 10.1314 14.5 10V4C14.5002 3.86862 14.4745 3.7385 14.4243 3.61708C14.3741 3.49567 14.3004 3.38535 14.2075 3.29245C14.1146 3.19956 14.0043 3.1259 13.8829 3.07572C13.7615 3.02553 13.6314 2.9998 13.5 3H3.5C3.36862 2.9998 3.2385 3.02553 3.11708 3.07572C2.99567 3.1259 2.88535 3.19956 2.79245 3.29245C2.69956 3.38535 2.6259 3.49567 2.57572 3.61708C2.52553 3.7385 2.4998 3.86862 2.5 4V10C2.4998 10.1314 2.52553 10.2615 2.57572 10.3829C2.6259 10.5043 2.69956 10.6146 2.79245 10.7075C2.88535 10.8004 2.99567 10.8741 3.11708 10.9243C3.2385 10.9745 3.36862 11.0002 3.5 11H8V12H3.5C2.96957 12 2.46086 11.7893 2.08579 11.4142C1.71071 11.0391 1.5 10.5304 1.5 10V4C1.49993 3.73734 1.55162 3.47724 1.65211 3.23456C1.75259 2.99187 1.89991 2.77137 2.08564 2.58564C2.27137 2.39991 2.49187 2.25259 2.73456 2.15211C2.97724 2.05162 3.23734 1.99993 3.5 2H13.5C13.7627 1.99993 14.0228 2.05162 14.2654 2.15211C14.5081 2.25259 14.7286 2.39991 14.9144 2.58564C15.1001 2.77137 15.2474 2.99187 15.3479 3.23456C15.4484 3.47724 15.5001 3.73734 15.5 4V10C15.5 10.5304 15.2893 11.0391 14.9142 11.4142C14.5391 11.7893 14.0304 12 13.5 12H11.0825L9.368 15Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function EditIcon() {
  return (
    <>
      <div title="edit image">
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.14645 2.35326C9.24015 2.25951 9.29279 2.13238 9.29279 1.99982C9.29279 1.86726 9.24015 1.74013 9.14645 1.64637V2.35326ZM9.14645 2.35326C9.14643 2.35328 9.14641 2.3533 9.14639 2.35332L8.707 2.79271L7.20711 1.29282L7.6465 0.853424C7.64652 0.853407 7.64654 0.853389 7.64655 0.853371C7.74031 0.759669 7.86744 0.707031 8 0.707031C8.13256 0.707031 8.25969 0.759669 8.35345 0.853371C8.35346 0.853389 8.35348 0.853407 8.3535 0.853424L9.14639 1.64632L9.14645 2.35326ZM7.29289 4.20682L3.00084 8.49887L1.13414 8.86565L1.50083 6.99909L5.793 2.70692L7.29289 4.20682Z"
            fill="black"
            stroke="#2C2E3A"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </>
  );
}
export function EditcircleIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#16FF96" />
        <path
          d="M16.1464 9.35326C16.2401 9.25951 16.2928 9.13238 16.2928 8.99982C16.2928 8.86726 16.2401 8.74013 16.1464 8.64637V9.35326ZM16.1464 9.35326C16.1464 9.35328 16.1464 9.3533 16.1464 9.35332L15.707 9.79271L14.2071 8.29282L14.6465 7.85342C14.6465 7.85341 14.6465 7.85339 14.6466 7.85337C14.7403 7.75967 14.8674 7.70703 15 7.70703C15.1326 7.70703 15.2597 7.75967 15.3534 7.85337C15.3535 7.85339 15.3535 7.85341 15.3535 7.85342L16.1464 8.64632L16.1464 9.35326ZM14.2929 11.2068L10.0008 15.4989L8.13414 15.8657L8.50083 13.9991L12.793 9.70692L14.2929 11.2068Z"
          fill="#2C2E3A"
          stroke="#2C2E3A"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function DeletecircleIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#FF1616" />
        <path
          d="M13.9203 8.31448L14.0704 8.5H9.92963L10.0797 8.31448L10.7386 7.5H13.2614L13.9203 8.31448ZM9 16V10H15V16C15 16.1326 14.9473 16.2598 14.8536 16.3536C14.7598 16.4473 14.6326 16.5 14.5 16.5H9.5C9.36739 16.5 9.24021 16.4473 9.14645 16.3536C9.05268 16.2598 9 16.1326 9 16Z"
          fill="white"
          stroke="white"
        />
      </svg>
    </>
  );
}
export function CancelRedIcon() {
  return (
    <>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.41663 1.4165L10.5833 10.5832M1.41663 10.5832L10.5833 1.4165"
          stroke="#FF1616"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function BtnRightIcon() {
  return (
    <>
      <svg
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 5H1M9 1L13 5L9 9"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function GetReceiptIcon() {
  return (
    <>
      <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3335 6V10C12.3335 10.1768 12.2633 10.3464 12.1382 10.4714C12.0132 10.5964 11.8436 10.6667 11.6668 10.6667C11.49 10.6667 11.3204 10.5964 11.1954 10.4714C11.0704 10.3464 11.0002 10.1768 11.0002 10V0.666667C11.0002 0.489856 10.9299 0.320286 10.8049 0.195262C10.6799 0.0702379 10.5103 0 10.3335 0H1.00016C0.823352 0 0.653782 0.0702379 0.528758 0.195262C0.403734 0.320286 0.333496 0.489856 0.333496 0.666667V10C0.333496 11.1027 1.23083 12 2.3335 12H11.6668C12.7695 12 13.6668 11.1027 13.6668 10V6H12.3335ZM8.3335 5.33333V6.66667H3.00016V5.33333H8.3335ZM3.00016 4V2.66667H8.3335V4H3.00016ZM8.3335 8V9.33333H6.3335V8H8.3335Z"
          fill="#1F1F1F"
        />
      </svg>
    </>
  );
}
export function ShippingIcon() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6 11H15.2V7.62187C15.2 7.225 15.0725 6.84375 14.8475 6.5625L12.35 3.44062C12.125 3.15937 11.82 3 11.5025 3H10.4V1.5C10.4 0.671875 9.8625 0 9.2 0H2.8C2.1375 0 1.6 0.671875 1.6 1.5V3H0.2C0.09 3 0 3.1125 0 3.25V3.75C0 3.8875 0.09 4 0.2 4H7C7.11 4 7.2 4.1125 7.2 4.25V4.75C7.2 4.8875 7.11 5 7 5H1C0.89 5 0.8 5.1125 0.8 5.25V5.75C0.8 5.8875 0.89 6 1 6H6.2C6.31 6 6.4 6.1125 6.4 6.25V6.75C6.4 6.8875 6.31 7 6.2 7H0.2C0.09 7 0 7.1125 0 7.25V7.75C0 7.8875 0.09 8 0.2 8H5.4C5.51 8 5.6 8.1125 5.6 8.25V8.75C5.6 8.8875 5.51 9 5.4 9H1.6V13C1.6 14.6562 2.675 16 4 16C5.325 16 6.4 14.6562 6.4 13H9.6C9.6 14.6562 10.675 16 12 16C13.325 16 14.4 14.6562 14.4 13H15.6C15.82 13 16 12.775 16 12.5V11.5C16 11.225 15.82 11 15.6 11ZM4 14.5C3.3375 14.5 2.8 13.8281 2.8 13C2.8 12.1719 3.3375 11.5 4 11.5C4.6625 11.5 5.2 12.1719 5.2 13C5.2 13.8281 4.6625 14.5 4 14.5ZM12 14.5C11.3375 14.5 10.8 13.8281 10.8 13C10.8 12.1719 11.3375 11.5 12 11.5C12.6625 11.5 13.2 12.1719 13.2 13C13.2 13.8281 12.6625 14.5 12 14.5ZM14 8H10.4V4.5H11.5025L14 7.62187V8Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export function CrossIcon() {
  return (
    <>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.4165 1.41699L10.5832 10.5837M1.4165 10.5837L10.5832 1.41699"
          stroke="#FF1616"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function VisaIcon() {
  return (
    <>
      <svg
        width="32"
        height="26"
        viewBox="0 0 32 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.116 11.6277C26.116 11.6277 26.538 13.6947 26.633 14.1277H24.778L25.667 11.7107C25.656 11.7277 25.85 11.2047 25.961 10.8827L26.116 11.6277ZM31.999 3.22169V22.7777C31.9988 23.4849 31.7177 24.1631 31.2176 24.6632C30.7175 25.1634 30.0393 25.4444 29.332 25.4447H2.66505C1.9578 25.4444 1.27959 25.1634 0.779486 24.6632C0.279384 24.1631 -0.00168809 23.4849 -0.00195312 22.7777V3.22169C-0.00168809 2.51444 0.279384 1.83623 0.779486 1.33613C1.27959 0.836024 1.9578 0.554953 2.66505 0.554688H29.332C30.0393 0.554953 30.7175 0.836024 31.2176 1.33613C31.7177 1.83623 31.9988 2.51444 31.999 3.22169ZM8.47105 17.1777L11.982 8.55569H9.62105L7.43805 14.4447L7.19905 13.2507L6.42105 9.28369C6.29305 8.73369 5.89905 8.57769 5.41005 8.55569H1.81605L1.77705 8.72769C2.60012 8.92961 3.38964 9.24959 4.12105 9.67769L6.11005 17.1777H8.47105ZM13.716 17.1887L15.116 8.55569H12.883L11.489 17.1887H13.716ZM21.488 14.3667C21.499 13.3837 20.899 12.6337 19.616 12.0167C18.833 11.6217 18.355 11.3557 18.355 10.9497C18.366 10.5827 18.761 10.2047 19.638 10.2047C20.2093 10.1886 20.7768 10.3007 21.299 10.5327L21.499 10.6267L21.805 8.75969C21.1667 8.5153 20.4886 8.39088 19.805 8.39269C17.599 8.39269 16.049 9.57069 16.038 11.2477C16.021 12.4867 17.149 13.1757 17.994 13.5917C18.855 14.0137 19.15 14.2917 19.15 14.6637C19.139 15.2417 18.45 15.5077 17.811 15.5077C16.922 15.5077 16.444 15.3687 15.716 15.0467L15.422 14.9077L15.111 16.8467C15.633 17.0857 16.6 17.2967 17.6 17.3077C19.944 17.3127 21.472 16.1517 21.489 14.3637L21.488 14.3667ZM29.332 17.1887L27.532 8.55569H25.804C25.271 8.55569 24.865 8.71169 24.637 9.27269L21.32 17.1897H23.664C23.664 17.1897 24.047 16.1227 24.131 15.8957H26.998C27.065 16.2017 27.265 17.1897 27.265 17.1897L29.332 17.1887Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function RightArrownIcon() {
  return (
    <>
      <svg
        width="9"
        height="14"
        viewBox="0 0 9 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.70898 1.5L7.20898 7L1.70898 12.5"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function StarIcon() {
  return (
    <>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.9019 7.47184L26.9019 7.47201L29.5769 15.702L29.5771 15.7025C29.7732 16.3039 30.1544 16.828 30.6663 17.1998C31.1781 17.5715 31.7944 17.772 32.4271 17.7725H32.4274H41.0824C43.0192 17.7725 43.8256 20.2522 42.2582 21.3932L35.2588 26.4777C34.7459 26.8498 34.364 27.3748 34.1678 27.9773C33.9717 28.5798 33.9713 29.229 34.1668 29.8317L34.1669 29.832L36.8419 38.062L36.842 38.0623C37.4416 39.9029 35.3328 41.4389 33.7613 40.2979C33.7613 40.2979 33.7612 40.2979 33.7612 40.2979L26.7613 35.2129L26.7612 35.2128C26.2488 34.8408 25.6319 34.6405 24.9987 34.6405C24.3655 34.6405 23.7486 34.8408 23.2362 35.2128L23.2361 35.2129L16.2361 40.2979L16.2359 40.298C14.6687 41.4375 12.5597 39.9048 13.158 38.0618L15.8329 29.832L15.833 29.8317C16.0286 29.229 16.0282 28.5798 15.832 27.9773C15.6359 27.3749 15.2541 26.85 14.7413 26.4779C14.7412 26.4778 14.7411 26.4778 14.741 26.4777L7.74421 21.3957C6.17729 20.2551 6.98507 17.775 8.91994 17.775H17.5723C17.5723 17.775 17.5724 17.775 17.5724 17.775C18.2055 17.7751 18.8224 17.5749 19.3349 17.2031C19.8473 16.8313 20.229 16.3069 20.4253 15.705L20.4254 15.7045L23.1005 7.47451L23.1372 7.36155C23.804 5.63007 26.3164 5.66857 26.9019 7.47184Z"
          fill="#16FF96"
          stroke="#2C2E3A"
        />
      </svg>
    </>
  );
}
export function StarBlankIcon() {
  return (
    <>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.9019 7.47184L26.9019 7.47201L29.5769 15.702L29.5771 15.7025C29.7732 16.3039 30.1544 16.828 30.6663 17.1998C31.1781 17.5715 31.7944 17.772 32.4271 17.7725H32.4274H41.0824C43.0192 17.7725 43.8256 20.2522 42.2582 21.3932L35.2588 26.4777C34.7459 26.8498 34.364 27.3748 34.1678 27.9773C33.9717 28.5798 33.9713 29.229 34.1668 29.8317L34.1669 29.832L36.8419 38.062L36.842 38.0623C37.4416 39.9029 35.3328 41.4389 33.7613 40.2979C33.7613 40.2979 33.7612 40.2979 33.7612 40.2979L26.7613 35.2129L26.7612 35.2128C26.2488 34.8408 25.6319 34.6405 24.9987 34.6405C24.3655 34.6405 23.7486 34.8408 23.2362 35.2128L23.2361 35.2129L16.2361 40.2979L16.2359 40.298C14.6687 41.4375 12.5597 39.9048 13.158 38.0618L15.8329 29.832L15.833 29.8317C16.0286 29.229 16.0282 28.5798 15.832 27.9773C15.6359 27.3749 15.2541 26.85 14.7413 26.4779C14.7412 26.4778 14.7411 26.4778 14.741 26.4777L7.74421 21.3957C6.17729 20.2551 6.98507 17.775 8.91994 17.775H17.5723C17.5723 17.775 17.5724 17.775 17.5724 17.775C18.2055 17.7751 18.8224 17.5749 19.3349 17.2031C19.8473 16.8313 20.229 16.3069 20.4253 15.705L20.4254 15.7045L23.1005 7.47451L23.1372 7.36155C23.804 5.63007 26.3164 5.66857 26.9019 7.47184Z"
          fill="white"
          stroke="#2C2E3A"
        />
      </svg>
    </>
  );
}
export function DownDarkIcon() {
  return (
    <>
      <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 1.25L7 6.75L1.5 1.25"
          stroke="#1F1F1F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function ImageIcon() {
  return (
    <>
      <svg
        width="37"
        height="37"
        viewBox="0 0 37 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.625 0C3.39837 0 2.22199 0.556886 1.35463 1.54815C0.487275 2.53941 0 3.88386 0 5.28571V31.7143C0 33.1161 0.487275 34.4606 1.35463 35.4518C2.22199 36.4431 3.39837 37 4.625 37H32.375C33.6016 37 34.778 36.4431 35.6454 35.4518C36.5127 34.4606 37 33.1161 37 31.7143V5.28571C37 3.88386 36.5127 2.53941 35.6454 1.54815C34.778 0.556886 33.6016 0 32.375 0H4.625ZM32.375 2.64286C32.9883 2.64286 33.5765 2.9213 34.0102 3.41693C34.4439 3.91256 34.6875 4.58478 34.6875 5.28571V22.4643L25.9532 17.3186C25.7363 17.1945 25.4908 17.1514 25.2513 17.1955C25.0119 17.2396 24.7906 17.3687 24.6189 17.5644L16.0395 27.3694L9.88825 22.6863C9.66616 22.5173 9.39976 22.4413 9.13423 22.4712C8.8687 22.501 8.62038 22.6349 8.43137 22.8501L2.3125 29.0714V5.28571C2.3125 4.58478 2.55614 3.91256 2.98982 3.41693C3.42349 2.9213 4.01169 2.64286 4.625 2.64286H32.375Z"
          fill="black"
        />
      </svg>
    </>
  );
}
export function SupprotBigIcon() {
  return (
    <>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.998 2.5C9.10555 2.5 3.49805 8.1075 3.49805 15C3.49805 21.8925 9.10555 27.5 15.998 27.5C22.8905 27.5 28.498 21.8925 28.498 15C28.498 8.1075 22.8905 2.5 15.998 2.5ZM17.248 22.5H14.748V20H17.248V22.5ZM18.468 16.3937C18.223 16.5912 17.9868 16.78 17.7993 16.9675C17.2893 17.4763 17.2493 17.9387 17.248 17.9587V18.125H14.748V17.9163C14.748 17.7688 14.7843 16.445 16.0305 15.1988C16.2743 14.955 16.5768 14.7075 16.8943 14.45C17.8118 13.7063 18.4143 13.1637 18.4143 12.4162C18.3998 11.7848 18.1387 11.1841 17.6869 10.7426C17.2351 10.3012 16.6285 10.0542 15.9968 10.0543C15.3652 10.0545 14.7587 10.3019 14.3071 10.7435C13.8555 11.1852 13.5947 11.786 13.5805 12.4175H11.0805C11.0805 9.70625 13.2868 7.5 15.998 7.5C18.7093 7.5 20.9155 9.70625 20.9155 12.4175C20.9155 14.4137 19.4418 15.605 18.468 16.3937Z"
          fill="black"
        />
      </svg>
    </>
  );
}
export function ShieldIcon() {
  return (
    <>
      <svg
        width="21"
        height="20"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1186_82863)">
          <path
            d="M15.998 22.5H14.123V20.625H15.998V22.5ZM15.998 5.625H14.123V18.75H15.998V5.625ZM15.0605 29.9561C13.8984 29.2725 12.7461 28.5449 11.6035 27.7734C10.4609 27.002 9.36719 26.167 8.32227 25.2686C7.27734 24.3701 6.31055 23.4131 5.42188 22.3975C4.5332 21.3818 3.75684 20.293 3.09277 19.1309C2.42871 17.9688 1.91602 16.7334 1.55469 15.4248C1.19336 14.1162 1.00781 12.7246 0.998047 11.25V3.75C1.80859 3.75 2.59473 3.7207 3.35645 3.66211C4.11816 3.60352 4.86035 3.49609 5.58301 3.33984C6.30566 3.18359 7.01855 2.96387 7.72168 2.68066C8.4248 2.39746 9.12793 2.03125 9.83105 1.58203C10.6611 1.04492 11.4912 0.649414 12.3213 0.395508C13.1514 0.141602 14.0645 0.00976562 15.0605 0C15.5586 0 16.0322 0.0292969 16.4814 0.0878906C16.9307 0.146484 17.3652 0.244141 17.7852 0.380859C18.2051 0.517578 18.625 0.683594 19.0449 0.878906C19.4648 1.07422 19.8799 1.30859 20.29 1.58203C20.9932 2.03125 21.6963 2.39746 22.3994 2.68066C23.1025 2.96387 23.8154 3.18359 24.5381 3.33984C25.2607 3.49609 26.0029 3.60352 26.7646 3.66211C27.5264 3.7207 28.3125 3.75 29.123 3.75V11.25C29.123 12.7246 28.9375 14.1162 28.5664 15.4248C28.1953 16.7334 27.6826 17.9688 27.0283 19.1309C26.374 20.293 25.6025 21.3818 24.7139 22.3975C23.8252 23.4131 22.8584 24.3652 21.8135 25.2539C20.7686 26.1426 19.6748 26.9775 18.5322 27.7588C17.3896 28.54 16.2324 29.2725 15.0605 29.9561ZM2.87305 5.5957V11.25C2.87305 12.4902 3.03418 13.6816 3.35645 14.8242C3.67871 15.9668 4.12793 17.0508 4.7041 18.0762C5.28027 19.1016 5.9541 20.0781 6.72559 21.0059C7.49707 21.9336 8.33691 22.8027 9.24512 23.6133C10.1533 24.4238 11.0957 25.1807 12.0723 25.8838C13.0488 26.5869 14.0449 27.2217 15.0605 27.7881C16.0566 27.2119 17.0479 26.5771 18.0342 25.8838C19.0205 25.1904 19.9678 24.4385 20.876 23.6279C21.7842 22.8174 22.624 21.9482 23.3955 21.0205C24.167 20.0928 24.8408 19.1162 25.417 18.0908C25.9932 17.0654 26.4375 15.9766 26.75 14.8242C27.0625 13.6719 27.2285 12.4805 27.248 11.25V5.5957C25.793 5.51758 24.4014 5.2832 23.0732 4.89258C21.7451 4.50195 20.4609 3.91113 19.2207 3.12012C18.5566 2.69043 17.8975 2.37793 17.2432 2.18262C16.5889 1.9873 15.8613 1.88477 15.0605 1.875C14.2695 1.875 13.5469 1.97266 12.8926 2.16797C12.2383 2.36328 11.5742 2.68066 10.9004 3.12012C9.66992 3.91113 8.39062 4.50195 7.0625 4.89258C5.73438 5.2832 4.33789 5.51758 2.87305 5.5957Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_1186_82863">
            <rect
              width="30"
              height="30"
              fill="white"
              transform="translate(0.998047)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
export function WhiteBagIcon() {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 7.875V25.625C3.75 25.9565 3.8817 26.2745 4.11612 26.5089C4.35054 26.7433 4.66848 26.875 5 26.875H25C25.3315 26.875 25.6495 26.7433 25.8839 26.5089C26.1183 26.2745 26.25 25.9565 26.25 25.625V7.875H3.75Z"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M26.25 7.875L22.7081 3.125H7.29187L3.75 7.875M19.7219 12C19.7219 14.6238 17.6081 16.75 15 16.75C12.3919 16.75 10.2775 14.6238 10.2775 12"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function WhiteSaveIcon() {
  return (
    <>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.14996 22.4375L15.4 19.75L21.65 22.4375V6.25H9.14996V22.4375ZM8.39996 25.5C7.9833 25.6667 7.58746 25.63 7.21246 25.39C6.83746 25.15 6.64996 24.8017 6.64996 24.345V6.25C6.64996 5.5625 6.89496 4.97375 7.38496 4.48375C7.87496 3.99375 8.4633 3.74917 9.14996 3.75H21.65C22.3375 3.75 22.9262 3.995 23.4162 4.485C23.9062 4.975 24.1508 5.56334 24.15 6.25V24.3438C24.15 24.8021 23.9625 25.1513 23.5875 25.3913C23.2125 25.6313 22.8166 25.6675 22.4 25.5L15.4 22.5L8.39996 25.5Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export const WhiteReservationIcon = () => {
  return (
    <>
      <svg
        width="23"
        height="26"
        viewBox="0 0 23 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.15 2.75H18.9V0.25H16.4V2.75H6.39996V0.25H3.89996V2.75H2.64996C1.27496 2.75 0.149963 3.875 0.149963 5.25V22.75C0.149963 23.413 0.413355 24.0489 0.882196 24.5178C1.35104 24.9866 1.98692 25.25 2.64996 25.25H20.15C21.5375 25.25 22.65 24.1375 22.65 22.75V5.25C22.65 4.58696 22.3866 3.95107 21.9177 3.48223C21.4489 3.01339 20.813 2.75 20.15 2.75ZM20.15 22.75H2.64996V10.25H20.15V22.75ZM20.15 7.75H2.64996V5.25H20.15M11.4 11.5C13.9 11.5 15.15 14.525 13.3875 16.3C11.6125 18.075 8.58746 16.8125 8.58746 14.3125C8.58746 12.75 9.83746 11.5 11.4 11.5ZM17.025 21.35V21.5H5.77496V21.35C5.77496 19.7875 8.27496 18.5375 11.4 18.5375C14.525 18.5375 17.025 19.7875 17.025 21.35Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export const WhiteCalendarIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="26"
        viewBox="0 0 24 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.75 12.75H8.25V15.25H5.75V12.75ZM23.25 5.25V22.75C23.25 24.1375 22.1375 25.25 20.75 25.25H3.25C2.58696 25.25 1.95107 24.9866 1.48223 24.5178C1.01339 24.0489 0.75 23.413 0.75 22.75V5.25C0.75 3.875 1.875 2.75 3.25 2.75H4.5V0.25H7V2.75H17V0.25H19.5V2.75H20.75C21.413 2.75 22.0489 3.01339 22.5178 3.48223C22.9866 3.95107 23.25 4.58696 23.25 5.25ZM3.25 7.75H20.75V5.25H3.25V7.75ZM20.75 22.75V10.25H3.25V22.75H20.75ZM15.75 15.25V12.75H18.25V15.25H15.75ZM10.75 15.25V12.75H13.25V15.25H10.75ZM5.75 17.75H8.25V20.25H5.75V17.75ZM15.75 20.25V17.75H18.25V20.25H15.75ZM10.75 20.25V17.75H13.25V20.25H10.75Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export function WhiteSearchIcon() {
  return (
    <>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.3 26.25L17.425 18.375C16.8 18.875 16.0812 19.2708 15.2687 19.5625C14.4562 19.8542 13.5917 20 12.675 20C10.4042 20 8.48249 19.2133 6.90999 17.64C5.33749 16.0667 4.55082 14.145 4.54999 11.875C4.54999 9.60417 5.33665 7.6825 6.90999 6.11C8.48332 4.5375 10.405 3.75083 12.675 3.75C14.9458 3.75 16.8675 4.53667 18.44 6.11C20.0125 7.68333 20.7992 9.605 20.8 11.875C20.8 12.7917 20.6542 13.6562 20.3625 14.4688C20.0708 15.2812 19.675 16 19.175 16.625L27.05 24.5L25.3 26.25ZM12.675 17.5C14.2375 17.5 15.5658 16.9529 16.66 15.8588C17.7542 14.7646 18.3008 13.4367 18.3 11.875C18.3 10.3125 17.7529 8.98417 16.6587 7.89C15.5646 6.79583 14.2367 6.24917 12.675 6.25C11.1125 6.25 9.78415 6.79708 8.68999 7.89125C7.59582 8.98542 7.04915 10.3133 7.04999 11.875C7.04999 13.4375 7.59707 14.7658 8.69124 15.86C9.7854 16.9542 11.1133 17.5008 12.675 17.5Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function WhiteMsgIcon() {
  return (
    <>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.6 2.5H5.59998C4.22498 2.5 3.09998 3.625 3.09998 5V20C3.09998 21.375 4.22498 22.5 5.59998 22.5H23.1L28.1 27.5V5C28.1 3.625 26.975 2.5 25.6 2.5ZM25.6 21.5L24.1 20H5.59998V5H25.6V21.5Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function WhiteProfileIcon() {
  return (
    <>
      <svg
        width="21"
        height="30"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.2001 0C11.5262 0 12.7979 0.526784 13.7356 1.46447C14.6733 2.40215 15.2001 3.67392 15.2001 5C15.2001 6.32608 14.6733 7.59785 13.7356 8.53553C12.7979 9.47322 11.5262 10 10.2001 10C8.87399 10 7.60222 9.47322 6.66454 8.53553C5.72686 7.59785 5.20007 6.32608 5.20007 5C5.20007 3.67392 5.72686 2.40215 6.66454 1.46447C7.60222 0.526784 8.87399 0 10.2001 0ZM10.2001 2.5C9.53703 2.5 8.90115 2.76339 8.43231 3.23223C7.96347 3.70107 7.70007 4.33696 7.70007 5C7.70007 5.66304 7.96347 6.29893 8.43231 6.76777C8.90115 7.23661 9.53703 7.5 10.2001 7.5C10.8631 7.5 11.499 7.23661 11.9678 6.76777C12.4367 6.29893 12.7001 5.66304 12.7001 5C12.7001 4.33696 12.4367 3.70107 11.9678 3.23223C11.499 2.76339 10.8631 2.5 10.2001 2.5ZM10.2001 11.25C13.5376 11.25 20.2001 12.9125 20.2001 16.25V20H0.200073V16.25C0.200073 12.9125 6.86257 11.25 10.2001 11.25ZM10.2001 13.625C6.48757 13.625 2.57507 15.45 2.57507 16.25V17.625H17.8251V16.25C17.8251 15.45 13.9126 13.625 10.2001 13.625Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function FilterIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.75 4.125L9.35 11.8333V17.6202L12.65 19.25V11.8333L19.25 4.125H2.75Z"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function CrossDarkIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.41663 6.4165L15.5833 15.5832M6.41663 15.5832L15.5833 6.4165"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function CrossRedIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.41663 6.4165L15.5833 15.5832M6.41663 15.5832L15.5833 6.4165"
          stroke="red"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function CrossWhiteIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.41663 6.4165L15.5833 15.5832M6.41663 15.5832L15.5833 6.4165"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function UpDarkIcon() {
  return (
    <>
      <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.95898 6.75L7.45898 1.25L12.959 6.75"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function MapLightIcon() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 20.1668C11 20.1668 17.875 14.6668 17.875 8.7085C17.875 4.91166 14.7968 1.8335 11 1.8335C7.20317 1.8335 4.125 4.91166 4.125 8.7085C4.125 14.6668 11 20.1668 11 20.1668Z"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M11 11.4585C11.3611 11.4585 11.7187 11.3874 12.0524 11.2492C12.386 11.111 12.6892 10.9084 12.9445 10.653C13.1999 10.3977 13.4025 10.0945 13.5407 9.76088C13.6789 9.42723 13.75 9.06963 13.75 8.7085C13.75 8.34736 13.6789 7.98976 13.5407 7.65612C13.4025 7.32247 13.1999 7.01931 12.9445 6.76395C12.6892 6.50859 12.386 6.30603 12.0524 6.16783C11.7187 6.02963 11.3611 5.9585 11 5.9585C10.2707 5.9585 9.57118 6.24823 9.05546 6.76395C8.53973 7.27968 8.25 7.97915 8.25 8.7085C8.25 9.43784 8.53973 10.1373 9.05546 10.653C9.57118 11.1688 10.2707 11.4585 11 11.4585V11.4585Z"
          stroke="white"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function FashionIcon() {
  return (
    <>
      <svg
        width="27"
        height="22"
        viewBox="0 0 27 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.375 9.125V21M16.7394 8.5C18.04 5.40875 21.2187 2.66688 22.875 1C23.565 1.41687 26 2.6275 26 5.375C26 7.875 25.0906 9.81938 24.125 10.375L20.3831 12.9944C18.7296 14.1519 17.3384 15.6447 16.3 17.3756L14.125 21H1V18.5C2.51812 17.6669 7.1375 14.8331 9.125 13.5C13.5 16 15.6875 11 16.7394 8.5Z"
          stroke="#455A64"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function BabyIcon() {
  return (
    <>
      <svg
        width="30"
        height="26"
        viewBox="0 0 30 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 13H11.0133M19 13H19.0133M12.3333 18.3333C13 18.7333 13.9333 19 15 19C16.0667 19 17 18.7333 17.6667 18.3333"
          stroke="#455A64"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.3334 5.4C25.5414 6.91423 26.3648 8.69837 26.7334 10.6C27.1843 10.8184 27.5645 11.1593 27.8305 11.5838C28.0966 12.0082 28.2377 12.499 28.2377 13C28.2377 13.501 28.0966 13.9918 27.8305 14.4162C27.5645 14.8407 27.1843 15.1816 26.7334 15.4C26.1578 18.0846 24.679 20.4907 22.5437 22.2167C20.4084 23.9427 17.7457 24.8843 15.0001 24.8843C12.2544 24.8843 9.5918 23.9427 7.4565 22.2167C5.32119 20.4907 3.84236 18.0846 3.26674 15.4C2.81589 15.1816 2.43566 14.8407 2.16961 14.4162C1.90356 13.9918 1.76245 13.501 1.76245 13C1.76245 12.499 1.90356 12.0082 2.16961 11.5838C2.43566 11.1593 2.81589 10.8184 3.26674 10.6C3.8191 7.894 5.28794 5.46136 7.42545 3.71249C9.56296 1.96362 12.2383 1.00557 15.0001 1C17.6667 1 19.6667 2.46667 19.6667 4.33333C19.6667 6.2 18.4667 7.66667 17.0001 7.66667C15.9334 7.66667 15.0001 7.13333 15.0001 6.33333"
          stroke="#455A64"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function BackIcon() {
  return (
    <>
      <svg
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.75 12.5L1.25 7L6.75 1.5"
          stroke="#1F1F1F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function StarsBlueIcon() {
  return (
    <>
      <svg
        width="19"
        height="25"
        viewBox="0 0 19 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.98672 9.36976C10.1517 8.87476 10.8507 8.87476 11.0157 9.36976L11.9832 12.2753C12.1962 12.914 12.555 13.4943 13.0312 13.9702C13.5074 14.4462 14.0879 14.8047 14.7267 15.0173L17.6308 15.9848C18.1258 16.1498 18.1258 16.8488 17.6308 17.0138L14.7252 17.9813C14.0865 18.1943 13.5062 18.5531 13.0303 19.0293C12.5543 19.5055 12.1958 20.086 11.9832 20.7248L11.0157 23.6288C10.9802 23.7372 10.9113 23.8316 10.8189 23.8985C10.7265 23.9654 10.6153 24.0015 10.5012 24.0015C10.3871 24.0015 10.276 23.9654 10.1836 23.8985C10.0912 23.8316 10.0223 23.7372 9.98672 23.6288L9.01922 20.7233C8.80641 20.0848 8.44784 19.5045 7.9719 19.0286C7.49597 18.5527 6.91575 18.1941 6.27721 17.9813L3.37169 17.0138C3.2633 16.9782 3.16891 16.9093 3.102 16.8169C3.03508 16.7245 2.99905 16.6134 2.99905 16.4993C2.99905 16.3852 3.03508 16.274 3.102 16.1816C3.16891 16.0893 3.2633 16.0204 3.37169 15.9848L6.27721 15.0173C6.91575 14.8045 7.49597 14.4459 7.9719 13.97C8.44784 13.494 8.80641 12.9138 9.01922 12.2753L9.98672 9.36976ZM4.1922 1.72123C4.21371 1.65627 4.25514 1.59974 4.31061 1.55967C4.36609 1.51961 4.43277 1.49804 4.5012 1.49804C4.56963 1.49804 4.63631 1.51961 4.69179 1.55967C4.74726 1.59974 4.78869 1.65627 4.8102 1.72123L5.3907 3.46423C5.6502 4.24124 6.25921 4.85024 7.03621 5.10974L8.77922 5.69024C8.84418 5.71175 8.9007 5.75319 8.94077 5.80866C8.98083 5.86413 9.0024 5.93082 9.0024 5.99924C9.0024 6.06767 8.98083 6.13436 8.94077 6.18983C8.9007 6.2453 8.84418 6.28674 8.77922 6.30825L7.03621 6.88875C6.653 7.01642 6.30478 7.2316 6.01917 7.51721C5.73355 7.80283 5.51838 8.15104 5.3907 8.53426L4.8102 10.2773C4.78869 10.3422 4.74726 10.3987 4.69179 10.4388C4.63631 10.4789 4.56963 10.5004 4.5012 10.5004C4.43277 10.5004 4.36609 10.4789 4.31061 10.4388C4.25514 10.3987 4.21371 10.3422 4.1922 10.2773L3.6117 8.53426C3.48402 8.15104 3.26885 7.80283 2.98323 7.51721C2.69762 7.2316 2.3494 7.01642 1.96619 6.88875L0.223182 6.30825C0.158223 6.28674 0.101695 6.2453 0.0616298 6.18983C0.0215646 6.13436 0 6.06767 0 5.99924C0 5.93082 0.0215646 5.86413 0.0616298 5.80866C0.101695 5.75319 0.158223 5.71175 0.223182 5.69024L1.96619 5.10974C2.3494 4.98207 2.69762 4.76689 2.98323 4.48128C3.26885 4.19566 3.48402 3.84745 3.6117 3.46423L4.1922 1.72123ZM14.7957 0.147719C14.8105 0.105009 14.8383 0.067973 14.8751 0.0417614C14.912 0.0155498 14.956 0.00146484 15.0012 0.00146484C15.0464 0.00146484 15.0905 0.0155498 15.1274 0.0417614C15.1642 0.067973 15.1919 0.105009 15.2067 0.147719L15.5937 1.30872C15.7662 1.82773 16.1727 2.23423 16.6917 2.40673L17.8528 2.79373C17.8955 2.80854 17.9325 2.83629 17.9587 2.87312C17.9849 2.90995 17.999 2.95403 17.999 2.99923C17.999 3.04444 17.9849 3.08852 17.9587 3.12535C17.9325 3.16218 17.8955 3.18992 17.8528 3.20473L16.6917 3.59173C16.436 3.67682 16.2036 3.82036 16.013 4.01096C15.8224 4.20156 15.6788 4.43397 15.5937 4.68974L15.2067 5.85074C15.1919 5.89345 15.1642 5.93049 15.1274 5.9567C15.0905 5.98291 15.0464 5.997 15.0012 5.997C14.956 5.997 14.912 5.98291 14.8751 5.9567C14.8383 5.93049 14.8105 5.89345 14.7957 5.85074L14.4087 4.68974C14.3237 4.43397 14.1801 4.20156 13.9895 4.01096C13.7989 3.82036 13.5665 3.67682 13.3107 3.59173L12.1512 3.20473C12.1085 3.18992 12.0715 3.16218 12.0453 3.12535C12.0191 3.08852 12.005 3.04444 12.005 2.99923C12.005 2.95403 12.0191 2.90995 12.0453 2.87312C12.0715 2.83629 12.1085 2.80854 12.1512 2.79373L13.3122 2.40673C13.8312 2.23423 14.2377 1.82773 14.4102 1.30872L14.7957 0.149219V0.147719Z"
          fill="#0074DF"
        />
      </svg>
    </>
  );
}
export function ListWhiteIcon() {
  return (
    <>
      <svg
        width="31"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.8 26.25C20.1125 26.25 19.5237 26.005 19.0337 25.515C18.5437 25.025 18.2992 24.4367 18.3 23.75V18.75C18.3 18.0625 18.545 17.4738 19.035 16.9838C19.525 16.4938 20.1133 16.2492 20.8 16.25H25.8C26.4875 16.25 27.0762 16.495 27.5662 16.985C28.0562 17.475 28.3008 18.0633 28.3 18.75V23.75C28.3 24.4375 28.055 25.0263 27.565 25.5163C27.075 26.0063 26.4867 26.2508 25.8 26.25H20.8ZM20.8 23.75H25.8V18.75H20.8V23.75ZM3.29999 22.5V20H14.55V22.5H3.29999ZM20.8 13.75C20.1125 13.75 19.5237 13.505 19.0337 13.015C18.5437 12.525 18.2992 11.9367 18.3 11.25V6.25C18.3 5.5625 18.545 4.97375 19.035 4.48375C19.525 3.99375 20.1133 3.74917 20.8 3.75H25.8C26.4875 3.75 27.0762 3.995 27.5662 4.485C28.0562 4.975 28.3008 5.56334 28.3 6.25V11.25C28.3 11.9375 28.055 12.5263 27.565 13.0163C27.075 13.5063 26.4867 13.7508 25.8 13.75H20.8ZM20.8 11.25H25.8V6.25H20.8V11.25ZM3.29999 10V7.5H14.55V10H3.29999Z"
          fill="white"
        />
      </svg>
    </>
  );
}
export function GreenPlusIcon() {
  return (
    <>
      <svg
        width="44"
        height="43"
        viewBox="0 0 44 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.2383 21.0713L30.8053 21.0895M22.0309 29.8639L22.0127 12.2969"
          stroke="#16FF96"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
export function MasterCardIcon() {
  return (
    <>
      <>
        <svg
          width="28"
          height="18"
          viewBox="0 0 28 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.2722 15.6944C13.3362 15.7491 13.4055 15.8037 13.4735 15.8571C12.122 16.7542 10.5356 17.232 8.91351 17.2304C7.83227 17.2313 6.76147 17.019 5.76233 16.6057C4.76319 16.1924 3.85533 15.5862 3.09065 14.8218C2.32598 14.0574 1.71949 13.1497 1.30588 12.1507C0.892273 11.1517 0.679651 10.081 0.680177 8.99974C0.680036 7.51057 1.08379 6.04924 1.84844 4.77137C2.61309 3.4935 3.71 2.44695 5.02236 1.74315C6.33473 1.03936 7.81341 0.704674 9.30093 0.774747C10.7884 0.844819 12.2291 1.31702 13.4695 2.14107C13.4028 2.1984 13.3362 2.2504 13.2855 2.30907C12.3244 3.13896 11.5533 4.16608 11.0246 5.32059C10.4959 6.4751 10.222 7.72992 10.2215 8.99974C10.2215 11.5664 11.3322 14.0064 13.2722 15.6944ZM19.0868 0.767738C17.4662 0.764586 15.881 1.24255 14.5322 2.14107C14.5975 2.1984 14.6642 2.2504 14.7148 2.30907C16.6642 3.99307 17.7802 6.4344 17.7802 8.99974C17.7802 11.5651 16.6668 14.0037 14.7295 15.6944C14.6642 15.7491 14.5948 15.8037 14.5282 15.8571C15.8785 16.7545 17.4642 17.2323 19.0855 17.2304C20.1753 17.2444 21.257 17.0418 22.2678 16.6344C23.2787 16.2271 24.1986 15.623 24.9742 14.8574C25.7498 14.0917 26.3656 13.1797 26.786 12.1741C27.2064 11.1686 27.4229 10.0896 27.4229 8.99975C27.423 7.90989 27.2067 6.83086 26.7865 5.82526C26.3663 4.81966 25.7506 3.90751 24.9752 3.14172C24.1997 2.37593 23.2799 1.77175 22.2691 1.36423C21.2583 0.956708 20.1766 0.753956 19.0868 0.767738ZM14.0002 2.53307C13.0199 3.30169 12.2276 4.28346 11.6833 5.40392C11.139 6.52437 10.8571 7.75408 10.8588 8.99974C10.8563 10.2461 11.1378 11.4767 11.6822 12.5979C12.2265 13.7191 13.0192 14.7015 14.0002 15.4704C14.9808 14.7012 15.7735 13.7187 16.318 12.5976C16.8625 11.4765 17.1446 10.2461 17.1428 8.99974C17.1447 7.75393 16.8626 6.5241 16.3181 5.4036C15.7735 4.28311 14.9808 3.30142 14.0002 2.53307Z"
            fill="white"
          />
        </svg>
      </>
    </>
  );
}

export function MasterCardIconColor() {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.99975 19.0162V17.8843C3.99975 17.4504 3.73558 17.1674 3.28277 17.1674C3.05641 17.1674 2.81115 17.2429 2.64134 17.4882C2.50934 17.2806 2.3207 17.1674 2.03771 17.1674C1.84899 17.1674 1.66045 17.224 1.50945 17.4315V17.2052H1.11328V19.0162H1.50945V18.0163C1.50945 17.6957 1.67927 17.5447 1.94344 17.5447C2.20744 17.5447 2.33961 17.7145 2.33961 18.0163V19.0162H2.73578V18.0163C2.73578 17.6957 2.92433 17.5447 3.16959 17.5447C3.43377 17.5447 3.56577 17.7145 3.56577 18.0163V19.0162H3.99975ZM9.86679 17.2052H9.22544V16.6581H8.82927V17.2052H8.47082V17.5635H8.82918V18.3937C8.82918 18.8088 8.99899 19.0539 9.4518 19.0539C9.62161 19.0539 9.81016 18.9974 9.94233 18.9219L9.82906 18.5823C9.71588 18.6578 9.58388 18.6767 9.48952 18.6767C9.30089 18.6767 9.22544 18.5635 9.22544 18.3748V17.5635H9.86679V17.2052ZM13.2249 17.1674C12.9985 17.1674 12.8476 17.2806 12.7533 17.4315V17.2052H12.3571V19.0162H12.7533V17.9975C12.7533 17.6957 12.8853 17.5259 13.1305 17.5259C13.206 17.5259 13.3003 17.5448 13.3758 17.5636L13.489 17.1864C13.4135 17.1674 13.3003 17.1674 13.2249 17.1674V17.1674ZM8.1501 17.3561C7.96138 17.224 7.6973 17.1674 7.4143 17.1674C6.96159 17.1674 6.65977 17.3938 6.65977 17.7522C6.65977 18.0541 6.88613 18.2239 7.2823 18.2805L7.47094 18.2994C7.67848 18.3371 7.79166 18.3937 7.79166 18.488C7.79166 18.62 7.64075 18.7144 7.37658 18.7144C7.11249 18.7144 6.90495 18.62 6.77287 18.5258L6.58423 18.8276C6.79177 18.9785 7.07477 19.0539 7.35767 19.0539C7.88593 19.0539 8.18783 18.8088 8.18783 18.4691C8.18783 18.1484 7.94256 17.9786 7.56521 17.9221L7.37658 17.9032C7.20677 17.8843 7.07477 17.8466 7.07477 17.7334C7.07477 17.6013 7.20677 17.5259 7.4143 17.5259C7.64075 17.5259 7.86711 17.6202 7.98029 17.6768L8.1501 17.3561ZM18.677 17.1674C18.4506 17.1674 18.2997 17.2806 18.2053 17.4315V17.2052H17.8091V19.0162H18.2053V17.9975C18.2053 17.6957 18.3374 17.5259 18.5826 17.5259C18.6581 17.5259 18.7525 17.5448 18.8279 17.5636L18.9411 17.1864C18.8656 17.1674 18.7525 17.1674 18.677 17.1674ZM13.6211 18.1107C13.6211 18.6578 13.9983 19.0539 14.5832 19.0539C14.8473 19.0539 15.0359 18.9974 15.2246 18.8465L15.0359 18.5258C14.885 18.639 14.7341 18.6955 14.5643 18.6955C14.2436 18.6955 14.0172 18.4691 14.0172 18.1107C14.0172 17.7712 14.2436 17.5447 14.5643 17.5259C14.7341 17.5259 14.885 17.5824 15.0359 17.6957L15.2246 17.375C15.0359 17.224 14.8473 17.1674 14.5832 17.1674C13.9983 17.1674 13.6211 17.5636 13.6211 18.1107ZM17.281 18.1107V17.2052H16.8848V17.4315C16.7527 17.2618 16.5641 17.1674 16.3188 17.1674C15.8095 17.1674 15.4133 17.5636 15.4133 18.1107C15.4133 18.6578 15.8095 19.0539 16.3188 19.0539C16.5829 19.0539 16.7716 18.9597 16.8848 18.7899V19.0162H17.281V18.1107ZM15.8283 18.1107C15.8283 17.79 16.0358 17.5259 16.3754 17.5259C16.6961 17.5259 16.9225 17.7712 16.9225 18.1107C16.9225 18.4314 16.6961 18.6955 16.3754 18.6955C16.0358 18.6766 15.8283 18.4314 15.8283 18.1107ZM11.0931 17.1674C10.5649 17.1674 10.1875 17.5447 10.1875 18.1107C10.1875 18.6767 10.5648 19.0539 11.1119 19.0539C11.376 19.0539 11.6402 18.9785 11.8477 18.8088L11.659 18.5258C11.5081 18.639 11.3195 18.7144 11.1308 18.7144C10.8856 18.7144 10.6403 18.6012 10.5837 18.2804H11.9232V18.1296C11.9421 17.5447 11.6025 17.1674 11.093 17.1674H11.0931ZM11.0931 17.507C11.3383 17.507 11.5082 17.658 11.5458 17.941H10.6026C10.6403 17.6957 10.8101 17.507 11.0931 17.507ZM20.922 18.1107V16.4883H20.5258V17.4315C20.3937 17.2618 20.2051 17.1674 19.9598 17.1674C19.4505 17.1674 19.0543 17.5636 19.0543 18.1107C19.0543 18.6578 19.4505 19.0539 19.9598 19.0539C20.224 19.0539 20.4126 18.9597 20.5258 18.7899V19.0162H20.922V18.1107ZM19.4694 18.1107C19.4694 17.79 19.6768 17.5259 20.0164 17.5259C20.3372 17.5259 20.5635 17.7712 20.5635 18.1107C20.5635 18.4314 20.3372 18.6955 20.0164 18.6955C19.6768 18.6766 19.4694 18.4314 19.4694 18.1107ZM6.22579 18.1107V17.2052H5.82962V17.4315C5.69753 17.2618 5.5089 17.1674 5.26363 17.1674C4.75428 17.1674 4.35811 17.5636 4.35811 18.1107C4.35811 18.6578 4.75428 19.0539 5.26363 19.0539C5.5278 19.0539 5.71644 18.9597 5.82962 18.7899V19.0162H6.22579V18.1107ZM4.75428 18.1107C4.75428 17.79 4.96182 17.5259 5.30136 17.5259C5.62208 17.5259 5.84852 17.7712 5.84852 18.1107C5.84852 18.4314 5.62208 18.6955 5.30136 18.6955C4.96182 18.6766 4.75428 18.4314 4.75428 18.1107Z"
          fill="black"
        />
        <path
          d="M8.01758 3.45264H13.9602V14.1305H8.01758V3.45264Z"
          fill="#FF5F00"
        />
        <path
          d="M8.39515 8.79156C8.39515 6.62206 9.41385 4.69775 10.9796 3.4526C9.82893 2.54708 8.37633 2 6.79164 2C3.03729 2 0 5.03729 0 8.79156C0 12.5457 3.03729 15.5831 6.79155 15.5831C8.37624 15.5831 9.82884 15.036 10.9796 14.1304C9.41385 12.9042 8.39515 10.961 8.39515 8.79156Z"
          fill="#EB001B"
        />
        <path
          d="M21.9777 8.79156C21.9777 12.5457 18.9404 15.5831 15.1861 15.5831C13.6014 15.5831 12.1488 15.036 10.998 14.1304C12.5827 12.8854 13.5826 10.961 13.5826 8.79156C13.5826 6.62206 12.5638 4.69775 10.998 3.4526C12.1488 2.54708 13.6014 2 15.1861 2C18.9404 2 21.9778 5.0562 21.9778 8.79156H21.9777Z"
          fill="#F79E1B"
        />
      </svg>
    </>
  );
}

export function VisaCardIconColor() {
  return (
    <>
      <svg
        enableBackground="new 0 0 780 500"
        height="25"
        viewBox="0 0 780 500"
        width="39"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m293.2 348.73 33.359-195.76h53.358l-33.384 195.76zm246.11-191.54c-10.569-3.966-27.135-8.222-47.821-8.222-52.726 0-89.863 26.551-90.181 64.604-.297 28.129 26.515 43.822 46.754 53.185 20.771 9.598 27.752 15.716 27.652 24.283-.133 13.123-16.586 19.115-31.924 19.115-21.355 0-32.701-2.967-50.225-10.273l-6.878-3.111-7.487 43.822c12.463 5.467 35.508 10.199 59.438 10.445 56.09 0 92.502-26.248 92.916-66.885.199-22.27-14.016-39.215-44.801-53.188-18.65-9.056-30.072-15.099-29.951-24.269 0-8.137 9.668-16.838 30.56-16.838 17.446-.271 30.088 3.534 39.936 7.5l4.781 2.259zm137.31-4.223h-41.23c-12.772 0-22.332 3.486-27.94 16.234l-79.245 179.4h56.031s9.159-24.121 11.231-29.418c6.123 0 60.555.084 68.336.084 1.596 6.854 6.492 29.334 6.492 29.334h49.512l-43.187-195.64zm-65.417 126.41c4.414-11.279 21.26-54.724 21.26-54.724-.314.521 4.381-11.334 7.074-18.684l3.606 16.878s10.217 46.729 12.353 56.527h-44.293zm-363.3-126.41-52.239 133.5-5.565-27.129c-9.726-31.274-40.025-65.157-73.898-82.12l47.767 171.2 56.455-.063 84.004-195.39-56.524-.001"
          fill="#0e4595"
        />
        <path
          d="m146.92 152.96h-86.041l-.682 4.073c66.939 16.204 111.23 55.363 129.62 102.42l-18.709-89.96c-3.229-12.396-12.597-16.096-24.186-16.528"
          fill="#f2ae14"
        />
      </svg>
    </>
  );
}
export function BookmarkIcon() {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75 22.4375L15 19.75L21.25 22.4375V6.25H8.75V22.4375ZM8 25.5C7.58333 25.6667 7.1875 25.63 6.8125 25.39C6.4375 25.15 6.25 24.8017 6.25 24.345V6.25C6.25 5.5625 6.495 4.97375 6.985 4.48375C7.475 3.99375 8.06333 3.74917 8.75 3.75H21.25C21.9375 3.75 22.5263 3.995 23.0163 4.485C23.5063 4.975 23.7508 5.56334 23.75 6.25V24.3438C23.75 24.8021 23.5625 25.1513 23.1875 25.3913C22.8125 25.6313 22.4167 25.6675 22 25.5L15 22.5L8 25.5Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export function BookmarkIconActive() {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.75 22.4375L15 19.75L21.25 22.4375V6.25H8.75V22.4375ZM8 25.5C7.58333 25.6667 7.1875 25.63 6.8125 25.39C6.4375 25.15 6.25 24.8017 6.25 24.345V6.25C6.25 5.5625 6.495 4.97375 6.985 4.48375C7.475 3.99375 8.06333 3.74917 8.75 3.75H21.25C21.9375 3.75 22.5263 3.995 23.0163 4.485C23.5063 4.975 23.7508 5.56334 23.75 6.25V24.3438C23.75 24.8021 23.5625 25.1513 23.1875 25.3913C22.8125 25.6313 22.4167 25.6675 22 25.5L15 22.5L8 25.5Z"
          fill="#16ff96"
          stroke="#16ff96"
        />
        <path
          d="M8.75 22.4375L15 19.75L21.25 22.4375V6.25H8.75V22.4375Z"
          fill="#16FF96"
          width="30"
          height="30"
        />
      </svg>
    </>
  );
}

export const PaginationLeftArrow = () => {
  return (
    <>
      <svg
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 1L1 6L6 11"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const PaginationRightArrow = () => {
  return (
    <>
      <svg
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L6 6L1 11"
          stroke="#1F1F1F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const EnvelopIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.334 2.66699H2.66732C2.3137 2.66699 1.97456 2.80747 1.72451 3.05752C1.47446 3.30756 1.33398 3.6467 1.33398 4.00033V12.0003C1.33398 12.3539 1.47446 12.6931 1.72451 12.9431C1.97456 13.1932 2.3137 13.3337 2.66732 13.3337H13.334C13.6876 13.3337 14.0267 13.1932 14.2768 12.9431C14.5268 12.6931 14.6673 12.3539 14.6673 12.0003V4.00033C14.6673 3.6467 14.5268 3.30756 14.2768 3.05752C14.0267 2.80747 13.6876 2.66699 13.334 2.66699ZM13.334 5.80033L8.00065 9.35633L2.66732 5.80033V4.19833L8.00065 7.75366L13.334 4.19833V5.80033Z"
          fill="#1F1F1F"
        />
      </svg>
    </>
  );
};

export const ArrowrightIcon = () => {
  return (
    <>
      <svg
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 5H1M9 1L13 5L9 9"
          stroke="#2C2E3A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const TrackingIcon = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6 11H15.2V7.62187C15.2 7.225 15.0725 6.84375 14.8475 6.5625L12.35 3.44062C12.125 3.15937 11.82 3 11.5025 3H10.4V1.5C10.4 0.671875 9.8625 0 9.2 0H2.8C2.1375 0 1.6 0.671875 1.6 1.5V3H0.2C0.09 3 0 3.1125 0 3.25V3.75C0 3.8875 0.09 4 0.2 4H7C7.11 4 7.2 4.1125 7.2 4.25V4.75C7.2 4.8875 7.11 5 7 5H1C0.89 5 0.8 5.1125 0.8 5.25V5.75C0.8 5.8875 0.89 6 1 6H6.2C6.31 6 6.4 6.1125 6.4 6.25V6.75C6.4 6.8875 6.31 7 6.2 7H0.2C0.09 7 0 7.1125 0 7.25V7.75C0 7.8875 0.09 8 0.2 8H5.4C5.51 8 5.6 8.1125 5.6 8.25V8.75C5.6 8.8875 5.51 9 5.4 9H1.6V13C1.6 14.6562 2.675 16 4 16C5.325 16 6.4 14.6562 6.4 13H9.6C9.6 14.6562 10.675 16 12 16C13.325 16 14.4 14.6562 14.4 13H15.6C15.82 13 16 12.775 16 12.5V11.5C16 11.225 15.82 11 15.6 11ZM4 14.5C3.3375 14.5 2.8 13.8281 2.8 13C2.8 12.1719 3.3375 11.5 4 11.5C4.6625 11.5 5.2 12.1719 5.2 13C5.2 13.8281 4.6625 14.5 4 14.5ZM12 14.5C11.3375 14.5 10.8 13.8281 10.8 13C10.8 12.1719 11.3375 11.5 12 11.5C12.6625 11.5 13.2 12.1719 13.2 13C13.2 13.8281 12.6625 14.5 12 14.5ZM14 8H10.4V4.5H11.5025L14 7.62187V8Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export const MsgIcon = () => {
  return (
    <>
      <svg
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.3335 0.333008H3.66683C1.8335 0.333008 0.333496 1.83301 0.333496 3.66634V23.6663C0.333496 25.4997 1.8335 26.9997 3.66683 26.9997H27.0002L33.6668 33.6663V3.66634C33.6668 1.83301 32.1668 0.333008 30.3335 0.333008ZM30.3335 25.6663L28.3335 23.6663H3.66683V3.66634H30.3335V25.6663Z"
          fill="#455A64"
        />
      </svg>
    </>
  );
};

export const QuestionIcon = () => {
  return (
    <>
      <svg
        width="144"
        height="144"
        viewBox="0 0 144 144"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_373_149)">
          <path
            d="M72 0C32.2057 0 0 32.202 0 72C0 111.794 32.202 144 72 144C111.794 144 144 111.798 144 72C144 32.2057 111.798 0 72 0ZM72 133.953C37.8388 133.953 10.0465 106.161 10.0465 72C10.0465 37.8385 37.8388 10.0465 72 10.0465C106.161 10.0465 133.953 37.8385 133.953 72C133.953 106.161 106.161 133.953 72 133.953Z"
            fill="white"
          />
          <path
            d="M69.8698 91.1036C65.8893 91.1036 62.667 94.4207 62.667 98.4009C62.667 102.287 65.7945 105.699 69.8698 105.699C73.9451 105.699 77.1671 102.287 77.1671 98.4009C77.1671 94.4207 73.8501 91.1036 69.8698 91.1036Z"
            fill="white"
          />
          <path
            d="M71.1012 35.8506C58.3065 35.8506 52.4307 43.4329 52.4307 48.5505C52.4307 52.2467 55.5582 53.9527 58.117 53.9527C63.2349 53.9527 61.15 46.6549 70.8168 46.6549C75.5553 46.6549 79.3466 48.7401 79.3466 53.0997C79.3466 58.2173 74.0391 61.1553 70.9116 63.8089C68.1629 66.1778 64.5618 70.0639 64.5618 78.2145C64.5618 83.1426 65.8888 84.5643 69.7742 84.5643C74.4179 84.5643 75.3658 82.4794 75.3658 80.6782C75.3658 75.7502 75.4605 72.907 80.6732 68.8317C83.232 66.8416 91.2876 60.3967 91.2876 51.4881C91.2876 42.5796 83.232 35.8506 71.1012 35.8506Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_373_149">
            <rect width="144" height="144" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ReviewCommentIcon = () => {
  return (
    <>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 4L9.456 5.8515L11.5 6.1485L10 7.5L10.5 9.5L8.5 8.375L6.5 9.5L7 7.5L5.5 6.1485L7.6 5.8515L8.5 4Z"
          fill="#1F1F1F"
        />
        <path
          d="M9.368 15L8.5 14.5L10.5 11H13.5C13.6314 11.0002 13.7615 10.9745 13.8829 10.9243C14.0043 10.8741 14.1146 10.8004 14.2075 10.7075C14.3004 10.6146 14.3741 10.5043 14.4243 10.3829C14.4745 10.2615 14.5002 10.1314 14.5 10V4C14.5002 3.86862 14.4745 3.7385 14.4243 3.61708C14.3741 3.49567 14.3004 3.38535 14.2075 3.29245C14.1146 3.19956 14.0043 3.1259 13.8829 3.07572C13.7615 3.02553 13.6314 2.9998 13.5 3H3.5C3.36862 2.9998 3.2385 3.02553 3.11708 3.07572C2.99567 3.1259 2.88535 3.19956 2.79245 3.29245C2.69956 3.38535 2.6259 3.49567 2.57572 3.61708C2.52553 3.7385 2.4998 3.86862 2.5 4V10C2.4998 10.1314 2.52553 10.2615 2.57572 10.3829C2.6259 10.5043 2.69956 10.6146 2.79245 10.7075C2.88535 10.8004 2.99567 10.8741 3.11708 10.9243C3.2385 10.9745 3.36862 11.0002 3.5 11H8V12H3.5C2.96957 12 2.46086 11.7893 2.08579 11.4142C1.71071 11.0391 1.5 10.5304 1.5 10V4C1.49993 3.73734 1.55162 3.47724 1.65211 3.23456C1.75259 2.99187 1.89991 2.77137 2.08564 2.58564C2.27137 2.39991 2.49187 2.25259 2.73456 2.15211C2.97724 2.05162 3.23734 1.99993 3.5 2H13.5C13.7627 1.99993 14.0228 2.05162 14.2654 2.15211C14.5081 2.25259 14.7286 2.39991 14.9144 2.58564C15.1001 2.77137 15.2474 2.99187 15.3479 3.23456C15.4484 3.47724 15.5001 3.73734 15.5 4V10C15.5 10.5304 15.2893 11.0391 14.9142 11.4142C14.5391 11.7893 14.0304 12 13.5 12H11.0825L9.368 15Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export const SendMsgIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7087 1.29199L12.6128 18.7087L9.12949 10.8712L1.29199 7.38782L18.7087 1.29199Z"
          stroke="black"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M18.709 1.29199L9.12988 10.8712"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const ChatBackIcon = () => {
  return (
    <>
      <svg
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.75 12.5L1.25 7L6.75 1.5"
          stroke="#1F1F1F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const ChatDetailsShowIcon = () => {
  return (
    <>
      <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 1.25L7 6.75L1.5 1.25"
          stroke="#1F1F1F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const NavBarLogo = () => {
  return (
    <>
      <svg
        version="1.2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 279"
        width="1000"
        height="279"
      >
        <path
          id="Layer"
          fillRule="evenodd"
          fill="#16ff96"
          d="m125.5 31c8.6 0 15.5-6.9 15.5-15.5 0-8.6-6.9-15.5-15.5-15.5-7.8 0-14.3 5.8-15.3 13.3-24.7 4-47.9 14.8-66.8 31.3-22.5 19.6-37.8 46.2-43.4 75.5l6.6 1.3c5.3-27.9 19.8-53.1 41.2-71.7 17.8-15.6 39.6-25.9 62.9-29.7 1.9 6.4 7.8 11 14.8 11zm137 88.5c-5.7-29.3-21.1-55.8-43.7-75.3l-4.4 5.1c21.5 18.5 36.1 43.7 41.6 71.5 4.6 23.4 2.5 47.6-6 69.7q-2-0.6-4.3-0.6c-8.6 0-15.5 6.9-15.5 15.5 0 8.5 6.9 15.5 15.5 15.5 8.5 0 15.5-7 15.5-15.5 0-4.6-2-8.8-5.2-11.6 9.1-23.6 11.4-49.3 6.5-74.3zm-174.4 152.3c28.2 9.7 58.9 9.6 87.1-0.2l-2.2-6.3c-26.8 9.3-55.9 9.4-82.8 0.2-23.1-7.9-43.4-22.3-58.5-41.3 2.9-2.8 4.7-6.8 4.7-11.1 0-8.5-7-15.5-15.5-15.5-8.6 0-15.5 7-15.5 15.5 0 8.6 6.9 15.5 15.5 15.5 1.8 0 3.5-0.3 5.1-0.9 16 20.4 37.5 35.7 62.1 44.1z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m336.9 78.4c0 21.8 12.8 36 37.5 41.6l24.9 5.7c14.4 3.3 20.9 10.9 20.9 22.8 0 15.1-12.8 24.5-32.8 24.5-19.1 0-31.2-9.2-31.7-23.7h-20.9c1.3 26 21.8 42.1 52.6 42.1 32.2 0 53.3-17.4 53.3-44.6 0-21.3-12.5-34.7-37.2-40.4l-24.9-5.8c-14.3-3.4-21.2-10.7-21.2-22.8 0-14.9 12.4-24.5 31.4-24.5 17 0 27.6 8.8 28.7 23.8h20.7c-1.7-26.1-20.3-42.2-49.2-42.2-31.2 0-52.1 17.6-52.1 43.5z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m482.8 188.7v-55.7c0-17.6 10.3-31.4 29.3-31.4 14.7 0 24.5 8.4 24.5 29.1v58.2h19.7v-62.6c0-26.1-12.6-42.7-38.7-42.7-15.9 0-28.3 7.6-34.8 18.7v-67.4h-19.6v153.8z"
        />
        <path
          id="Layer"
          fillRule="evenodd"
          fill="#ffffff"
          d="m578.5 160.4c0-18.8 14-30.5 38.1-32.4l32.2-2.5v-2.9c0-17.2-10.2-23.3-24-23.3-16.6 0-26 7.3-26 19.7h-17.1c0-21.4 17.5-35.4 43.9-35.4 25.3 0 42.5 13.4 42.5 41v64.3h-16.7l-2.1-16.5c-5.3 11.7-19.3 19-35.8 19-22 0-35-12.4-35-31zm70.6-15.7v-5.4l-26.2 2.1c-17.4 1.7-24.5 8.4-24.5 18.4 0 10.9 8 16.3 20.7 16.3 18.6 0 30-12.1 30-31.4z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m705.8 188.9l25.1-37.5 25.6 37.5h22.8l-35-50.7 35.6-51.6h-22.4l-25.3 38-26-38h-22.8l35.6 51.6-35.8 50.7z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m805.9 62.3c-7.1 0-12.9-5.8-12.9-13 0-7.2 5.8-13 12.9-13 7.2 0 13 5.8 13 13 0 7.2-5.8 13-13 13zm-9.6 24.3h19.7v102.3h-19.7z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m833.7 86.6v16.5h15v85.8h19.7v-85.8h24.3v-16.5h-24.3v-16.4c0-11.1 3.4-17.5 16.1-17.5h8.8v-17c-4-0.6-8.3-0.8-12.1-0.8-18.6 0-32.5 10.2-32.5 35.3v16.4z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m901.1 234.7c5.3 1.3 10.7 2.1 17.2 2.1 15.7 0 26-7.3 32.9-24.9l48.3-125.3h-20.3l-30.3 82.4-29.8-82.4h-20.7l41.3 107.7-3.6 9.9c-4.8 12.9-12.3 14.4-21.8 14.4h-13.2z"
        />
      </svg>
    </>
  );
};

export const NavBarMobileLogo = () => {
  return (
    <>
      <svg
        version="1.2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 279"
        width="1000"
        height="279"
      >
        <path
          id="Layer"
          fillRule="evenodd"
          fill="#16ff96"
          d="m125.5 31c8.6 0 15.5-6.9 15.5-15.5 0-8.6-6.9-15.5-15.5-15.5-7.8 0-14.3 5.8-15.3 13.3-24.7 4-47.9 14.8-66.8 31.3-22.5 19.6-37.8 46.2-43.4 75.5l6.6 1.3c5.3-27.9 19.8-53.1 41.2-71.7 17.8-15.6 39.6-25.9 62.9-29.7 1.9 6.4 7.8 11 14.8 11zm137 88.5c-5.7-29.3-21.1-55.8-43.7-75.3l-4.4 5.1c21.5 18.5 36.1 43.7 41.6 71.5 4.6 23.4 2.5 47.6-6 69.7q-2-0.6-4.3-0.6c-8.6 0-15.5 6.9-15.5 15.5 0 8.5 6.9 15.5 15.5 15.5 8.5 0 15.5-7 15.5-15.5 0-4.6-2-8.8-5.2-11.6 9.1-23.6 11.4-49.3 6.5-74.3zm-174.4 152.3c28.2 9.7 58.9 9.6 87.1-0.2l-2.2-6.3c-26.8 9.3-55.9 9.4-82.8 0.2-23.1-7.9-43.4-22.3-58.5-41.3 2.9-2.8 4.7-6.8 4.7-11.1 0-8.5-7-15.5-15.5-15.5-8.6 0-15.5 7-15.5 15.5 0 8.6 6.9 15.5 15.5 15.5 1.8 0 3.5-0.3 5.1-0.9 16 20.4 37.5 35.7 62.1 44.1z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m336.9 78.4c0 21.8 12.8 36 37.5 41.6l24.9 5.7c14.4 3.3 20.9 10.9 20.9 22.8 0 15.1-12.8 24.5-32.8 24.5-19.1 0-31.2-9.2-31.7-23.7h-20.9c1.3 26 21.8 42.1 52.6 42.1 32.2 0 53.3-17.4 53.3-44.6 0-21.3-12.5-34.7-37.2-40.4l-24.9-5.8c-14.3-3.4-21.2-10.7-21.2-22.8 0-14.9 12.4-24.5 31.4-24.5 17 0 27.6 8.8 28.7 23.8h20.7c-1.7-26.1-20.3-42.2-49.2-42.2-31.2 0-52.1 17.6-52.1 43.5z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m482.8 188.7v-55.7c0-17.6 10.3-31.4 29.3-31.4 14.7 0 24.5 8.4 24.5 29.1v58.2h19.7v-62.6c0-26.1-12.6-42.7-38.7-42.7-15.9 0-28.3 7.6-34.8 18.7v-67.4h-19.6v153.8z"
        />
        <path
          id="Layer"
          fillRule="evenodd"
          fill="#ffffff"
          d="m578.5 160.4c0-18.8 14-30.5 38.1-32.4l32.2-2.5v-2.9c0-17.2-10.2-23.3-24-23.3-16.6 0-26 7.3-26 19.7h-17.1c0-21.4 17.5-35.4 43.9-35.4 25.3 0 42.5 13.4 42.5 41v64.3h-16.7l-2.1-16.5c-5.3 11.7-19.3 19-35.8 19-22 0-35-12.4-35-31zm70.6-15.7v-5.4l-26.2 2.1c-17.4 1.7-24.5 8.4-24.5 18.4 0 10.9 8 16.3 20.7 16.3 18.6 0 30-12.1 30-31.4z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m705.8 188.9l25.1-37.5 25.6 37.5h22.8l-35-50.7 35.6-51.6h-22.4l-25.3 38-26-38h-22.8l35.6 51.6-35.8 50.7z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m805.9 62.3c-7.1 0-12.9-5.8-12.9-13 0-7.2 5.8-13 12.9-13 7.2 0 13 5.8 13 13 0 7.2-5.8 13-13 13zm-9.6 24.3h19.7v102.3h-19.7z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m833.7 86.6v16.5h15v85.8h19.7v-85.8h24.3v-16.5h-24.3v-16.4c0-11.1 3.4-17.5 16.1-17.5h8.8v-17c-4-0.6-8.3-0.8-12.1-0.8-18.6 0-32.5 10.2-32.5 35.3v16.4z"
        />
        <path
          id="Layer"
          fill="#ffffff"
          d="m901.1 234.7c5.3 1.3 10.7 2.1 17.2 2.1 15.7 0 26-7.3 32.9-24.9l48.3-125.3h-20.3l-30.3 82.4-29.8-82.4h-20.7l41.3 107.7-3.6 9.9c-4.8 12.9-12.3 14.4-21.8 14.4h-13.2z"
        />
      </svg>
    </>
  );
};

export const MyLocation = () => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      version="1.1"
      // xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      {/* <title>ic_fluent_my_location_24_regular</title>
      <desc>Created with Sketch.</desc> */}
      <g
        id="🔍-Product-Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="ic_fluent_my_location_24_regular"
          fill="#212121"
          fillRule="nonzero"
        >
          <path
            d="M12,2 C12.3796958,2 12.693491,2.28215388 12.7431534,2.64822944 L12.75,2.75 L12.7490685,4.53770881 L12.7490685,4.53770881 C16.292814,4.88757432 19.1124257,7.70718602 19.4632195,11.2525316 L19.5,11.25 L21.25,11.25 C21.6642136,11.25 22,11.5857864 22,12 C22,12.3796958 21.7178461,12.693491 21.3517706,12.7431534 L21.25,12.75 L19.4616558,12.7490368 L19.4616558,12.7490368 C19.1124257,16.292814 16.292814,19.1124257 12.7474684,19.4632195 L12.75,19.5 L12.75,21.25 C12.75,21.6642136 12.4142136,22 12,22 C11.6203042,22 11.306509,21.7178461 11.2568466,21.3517706 L11.25,21.25 L11.2509632,19.4616558 L11.2509632,19.4616558 C7.70718602,19.1124257 4.88757432,16.292814 4.53678051,12.7474684 L4.5,12.75 L2.75,12.75 C2.33578644,12.75 2,12.4142136 2,12 C2,11.6203042 2.28215388,11.306509 2.64822944,11.2568466 L2.75,11.25 L4.53770881,11.2509315 L4.53770881,11.2509315 C4.88757432,7.70718602 7.70718602,4.88757432 11.2525316,4.53678051 L11.25,4.5 L11.25,2.75 C11.25,2.33578644 11.5857864,2 12,2 Z M12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 Z M12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 C9.790861,16 8,14.209139 8,12 C8,9.790861 9.790861,8 12,8 Z"
            id="🎨-Color"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const TrashIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="#fff"
      className="bi bi-trash"
      viewBox="0 0 16 16"
    >
      {" "}
      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />{" "}
      <path
        fillRule="evenodd"
        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
      />{" "}
    </svg>
  );
};

export const ChatDetailsHideIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.95801 13.75L11.458 8.25L16.958 13.75"
        stroke="black"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export function BackLongIcon() {
  return (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 5L13 5M5 9L1 5L5 1"
        stroke="#2C2E3A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
